import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { ScrollableContainer } from '@ergeon/core-components';

import Footer from 'components/common/Footer';
import WikiSidebar from 'components/wiki/sidebar/WikiSidebar';

import TopPanel from './components/TopPanel';

const SIDEBAR_CLASSES = classNames(
  'fixed bottom-0 left-0 top-16 z-20 hidden w-64 border-r border-gray-200 bg-gray-50',
  'lg:block dark:border-gray-800 dark:bg-gray-900',
);

type WikiShellProps = {
  children: ReactNode;
  ergeonUrl: string;
  isLoggedIn: boolean;
};

const getContentOffset = (isLoggedIn: boolean) => {
  if (isLoggedIn) {
    return 'lg:pl-64';
  }
  return '';
};

const WikiShell = ({ children, ergeonUrl, isLoggedIn }: WikiShellProps) => (
  <div className="flex min-h-screen flex-col bg-white font-base text-gray-900 dark:bg-gray-900 dark:text-white">
    <TopPanel ergeonUrl={ergeonUrl} isLoggedIn={isLoggedIn} />
    {isLoggedIn && (
      <aside aria-label="Wiki navigation" className={SIDEBAR_CLASSES}>
        <ScrollableContainer className="px-3" direction="col" maskSize={6}>
          <WikiSidebar className="min-h-full w-full shrink-0" hasKeyboardHints />
        </ScrollableContainer>
      </aside>
    )}
    <div className={classNames('flex flex-1 flex-col', getContentOffset(isLoggedIn))}>
      <main className="flex-1">{children}</main>
      <Footer ergeonUrl={ergeonUrl} />
    </div>
  </div>
);

export default WikiShell;
